import { parseDate } from '../helpers'
import { Marshaller } from '../types/core'

const marshaller: Marshaller<Date, string> = {
  unmarshal: parseDate,
  marshal: model => model.toISOString(),
}

export default marshaller
